var thisColumnID = 0;
var page = 1;
var videoUploadPath = null;
var picUploadPath = null;

$(function () {
    thisColumnID = $('input[name=parentColumn]').val();
    var columns = getColumnChildren(thisColumnID);
    if (columns && columns.length > 0) {
        var html = '';
        for (var i = 0; i < columns.length; i++) {
            var info = columns[i];
            html += '<div class="child" data-id="' + info.id + '">' + info.name + '</div>\n';
        }
        $('.children').html(html);

        $('.children .child').on('click', function () {
            page = 1;
            $('.list .newsItems').html('');

            if (!$(this).hasClass('selected')) {
                $('.children .child').removeClass('selected');
                $(this).addClass('selected');
                thisColumnID = $(this).data('id');
                getContents(thisColumnID);
            } else {
                $('.children .child').removeClass('selected');
                thisColumnID = $('input[name=parentColumn]').val();
                getContents(thisColumnID);
            }
        });
    } else {
        $('.children').css('display', 'none');
    }
    getContents(thisColumnID);
    // getRecommends();
    // getHots();
    // getNewest();
    getSlides();

    $('.home-recommends .more').on('click', function () {
        location.href = ROOT + '/recommends';
    });

    $('.list .more').on('click', function () {
        getContents(thisColumnID);
    });
});
function getSlides() {
    var data = getColumnList('slider', 1, 20)
    if (!data || !data.data || data.data.length == 0) {
        return
    }
    data = data.data
    var newlist = ''
    for (var i = 0; i < data.length; i++) {
        var info = data[i]
        newlist +=
            '<div class="news-item"><a href="' +
            info.url +
            '" target="_blank">' +
            info.title +
            '</a></div>'
    }

    $('.newest .newest-list').html(newlist)
}
function getContents(id) {
    if (!id) return;

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/contents?id=' + id + '&page=' + page + '&size=10',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '') {
                return;
            }
            if (data.message !== undefined) {
                alert('操作失败:' + data.message);
                return;
            }
            if (data.data === undefined) {
                alert('操作失败');
                return;
            }
            var ad = {};
            if (id != null && id != 0) {
                ad = getListAds(id, 10 * page - 9, 10 * page);
            }
            var newlist = toListHtml(data, ad, page * 10 - 9);

            $('.list .newsItems').append(newlist);
            page++;

            if (data.data.length < 10) {
                $('.list .more').addClass('no-more');
            }

            if ($('.newsItem').length == 0)
                $('.list').html('<div style="text-align: center;">暂无内容</div>');
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert('获取列表失败:' + data.message);
            else
                alert('获取列表失败');
        }
    });
}


function getRecommends() {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/contents?id=recommend&page=' + page + '&size=5',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '')
                return;
            if (data.message !== undefined) {
                return;
            }
            if (data.data === undefined) {
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                newlist += '<div class="recommends-item">';
                newlist += '<div class="recommends-item-title"><a href="' + info.url + '" target="_blank">' + info.title + '</a></div>';
                newlist += '<div class="recommends-item-time">' + info.publish_time + '</div>';
                newlist += '</div>';
            }

            $('.recommend .recommends-items').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getHots() {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/hots',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.length; i++) {
                var info = data[i];
                if (i < 3) {
                    newlist += '<div class="hots-item top3">';
                } else {
                    newlist += '<div class="hots-item">';
                }
                newlist += '<div class="hots-item-number">' + (i + 1) + '</div>';
                newlist += '<div class="hots-item-title"><a href="' + info.url + '" target="_blank">' + info.title + '</a></div>';
                newlist += '</div>';
            }

            $('.hots .hots-list').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function toListHtml(data, advertisement, index) {
    var newlist = '';
    for (var i = 0; i < data.data.length; i++) {
        // 列表广告
        if (advertisement && advertisement[index + i]) {
            var ad = advertisement[index + i];
            var url = '/ads-click?id=' + ad.id + '&ad_id=' + ad.ad.id + '&ad_type=4' + '&url=' + encodeURIComponent(ad.ad.link_url);
            if (ad.list_mode == 0) { // 单图
                newlist += '<div class="newsItem">';
                if (ad.show_pictures.length > 0) {
                    newlist += '<div class="ads-picture">';
                    newlist += '<a href="' + url + '" target="_blank"><img src="' + ad.show_pictures[0] + '?w=170&h=114&s=3' + '"/></a>';
                    newlist += '</div>';
                }
                newlist += '<a class="ads-title" href="' + url + '" target="_blank">' + ad.name + '</a>';
                newlist += '<div class="ad-tag">广告</div>';
                newlist += '</div>';
                newlist += '<div class="dividing-line"></div>';
            } else if (ad.list_mode == 1) { // 三图
                newlist += '<div class="newsItem">';
                newlist += '<div class="news_body">';
                newlist += '<a class="news_title" href="' + url + '" target="_blank">' + ad.name + '</a>';
                newlist += '<div class="adPicture">';
                for (var j = 0; j < ad.show_pictures.length; j++) {
                    if (j == 3) break;
                    newlist += '<a href="' + url + '" target="_blank"><img src="' + ad.show_pictures[j] + '?w=224&h=140&s=3' + '"/></a>';
                }
                newlist += '</div>';
                newlist += '</div>';
                newlist += '<div class="ad-tag">广告</div>';
                newlist += '</div>';
                newlist += '<div class="dividing-line"></div>';
            } else if (ad.list_mode == 2) { // 大图
                newlist += '<div class="newsItem">';
                if (ad.show_pictures.length > 0) {
                    newlist += '<div class="ads-picture big">';
                    newlist += '<a href="' + url + '" target="_blank"><img src="' + ad.show_pictures[0] + '?w=320&h=200&s=3' + '"/></a>';
                    newlist += '</div>';
                }
                newlist += '<a class="ads-title" href="' + url + '" target="_blank">' + ad.name + '</a>';
                newlist += '<div class="ad-tag">广告</div>';
                newlist += '</div>';
                newlist += '<div class="dividing-line"></div>';
            } else if (ad.list_mode == 4) { // 横幅
                newlist += '<div class="newsItem">';
                newlist += '<a href="' + url + '" target="_blank"><img src="' + ad.show_pictures[0] + '?w=746&h=114&s=3' + '"/></a>';
                newlist += '<div class="ad-tag">广告</div>';
                newlist += '</div>';
                newlist += '<div class="dividing-line"></div>';
            }
        }

        var info = data.data[i];
        if (info.thumbnail_urls === undefined || info.thumbnail_urls == null || info.thumbnail_urls == '')
            info.thumbnail_urls = [];

        var bottominfo = '';
        bottominfo += '<div class="news_info">';
        bottominfo += '<div class="user">' + info.author_nickname + '</div>';
        bottominfo += '<div class="time">' + info.publish_time + '</div>';
        bottominfo += '<div class="reply">';
        if (info.comment_count > 0)
            bottominfo += '<div class="reply_count">' + info.comment_count + '评论</div>';
        if (info.view_count > 0)
            bottominfo += '<div class="reply_count">' + info.view_count + '浏览</div>';
        bottominfo += '</div>';
        if (info.source)
            bottominfo += '<div class="source">来源: ' + info.source + '</div>';
        bottominfo += '</div>';

        newlist += '<div class="newsItem">';
        // 只显示有图和无图两种情况
        if (info.list_item_mode == 0 || info.thumbnail_urls.length == 0 || !info.thumbnail_urls[0]) { // 无图
            newlist += '<div class="newsInfo">';
            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.summary)
                newlist += info.summary;
            newlist += '</div>';
            newlist += '</div>';
            newlist += bottominfo;
            newlist += '</div>';
        } else {
            newlist += '<div class="newsPicture">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            newlist += '<img src="' + info.thumbnail_urls[0] + '?w=200&h=150&s=3' + '"/>';
            newlist += '</a>';
            newlist += '</div>';
            newlist += '<div class="newsInfo">';

            newlist += '<div class="news_body">';
            newlist += '<a class="news_title" href="' + info.url + '" target="_blank">' + info.title + '</a>';
            newlist += '<div class="news_content">';
            if (info.summary)
                newlist += info.summary;
            newlist += '</div>';
            newlist += '</div>';
            newlist += bottominfo;
            newlist += '</div>';
        }
        newlist += '</div>';
        newlist += '<div class="dividing-line"></div>';
    }
    return newlist;
}

function getNewest() {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/home/newest',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.length; i++) {
                var info = data[i];

                newlist += '<div class="newest-item">';
                newlist += '<div class="newest-item-img">';
                newlist += '<a href="' + info.url + '">';
                if (info.thumbnail_urls && info.thumbnail_urls.length > 0 && info.thumbnail_urls[0]) {
                    newlist += '<img src="' + info.thumbnail_urls[0] + '?w=242&h=152&s=3"/>';
                } else {
                    newlist += '<img src="' + ROOT + '/static/images/no-thumb.png"/>';
                }
                newlist += '</a>';
                newlist += '</div>';
                newlist += '<div class="newest-item-tilte">';
                newlist += '<a href="' + info.url + '">' + info.title + '</a>';
                newlist += '</div>';
                // newlist += '<div class="newest-item-time">' + info.publish_time + '</div>';
                newlist += '</div>';
            }

            $('.newest .newest-list').html(newlist);
        },
        error: function (data) {
            console.log(data);
        }
    });
}

$(function () {
    $('.btn_video').on('click', function () {
        $('.add_pic_pop').css('display', 'none');
        $('.add_video_pop').css('display', 'block');
    });

    $('.btn_picture').on('click', function () {
        $('.add_pic_pop').css('display', 'block');
        $('.add_video_pop').css('display', 'none');
    });

    $('.pop_close').on('click', function () {
        $('.add_pic_pop').css('display', 'none');
        $('.add_video_pop').css('display', 'none');
    });

    $('.add_thread .btn_publish').on('click', function () {
        if ($('.add_content').val() == '') {
            alert('请先分享点什么！');
            return;
        }
        var pictures = [];
        for (var i = 0; i < $('.add_pic_pop .added_list .attachment_path').length; i++) {
            pictures.push($('.add_pic_pop .added_list .attachment_path').eq(i).val());
        }

        var videos = [];
        for (var i = 0; i < $('.add_video_pop .added_list .video-attachment-path').length; i++) {
            videos.push({
                paths: [$('.add_video_pop .added_list .video-attachment-path').eq(i).val()]
            });
        }

        var data = {
            'body': $('.add_content').val(),
            'pictures': pictures,
            'videos': videos,
            'real_name': '匿名',
            'phone_number': '13012345678',
            'geo_latitude': 0,
            'geo_longitude': 0,
            'geo_address': ''
        };

        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/user/revelation',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    alert('发表失败:' + data.message);
                    return;
                } else {
                    alert('发表成功！');
                    location.reload();
                }
            },
            error: function (data) {
                if (data.message !== undefined) {
                    console.log(data.message);
                    alert('发表失败:' + data.message);
                } else {
                    console.log(data);
                    alert('发表失败');
                }
            }
        });
    });
});

$(document).on('change', '#add_video_file', function (event) {
    var ele = $(this);
    var files = ele[0].files;

    if (!files || !files[0]) {
        return;
    }

    if (!videoUploadPath) {
        videoUploadPath = getVideoUploader();
        if (!videoUploadPath) {
            alert('获取视频上传地址失败');
            return;
        }
    }

    var attachmentName = files[0].name;
    var html = '';
    html += '<div class="add-video-item">';
    html += '<div class="add-video-name">' + attachmentName + '</div>';
    html += '<div class="add-video-progress">0%</div>';
    html += '<div class="add-video-item-delete">移除';
    html += '<input type="hidden" class="video-attachment-name" value="" />';
    html += '<input type="hidden" class="video-attachment-path" value="" />';
    html += '</div>';
    html += '</div>';

    $('.add_video_pop .added_list').append(html);

    var fd = new FormData();
    fd.append('onefile', files[0]);
    var xhr = new XMLHttpRequest();
    xhr.open('POST', videoUploadPath);
    // 进度条
    xhr.upload.onprogress = function (evt) {
        if (evt.lengthComputable) {
            // evt.loaded：文件上传的大小   evt.total：文件总的大小
            // 加载进度条，同时显示信息
            var percentComplete = (evt.loaded) * 100.0 / evt.total;

            var loaded = evt.loaded;
            var tot = evt.total;
            var per = Math.floor(100 * loaded / tot); // 已经上传的百分比
            $('.add-video-progress').text(per + '%');

            // xhr.abort();
        }
    };

    // 上传完成
    xhr.onload = function (data) {
        var jsonStr = data.target.responseText;
        jsonStr = eval('(' + jsonStr + ')');
        if (jsonStr != null && jsonStr.isOK) {
            // jsonStr.relativepath + jsonStr.files[i].name

            $('.video-attachment-name:last').val(jsonStr.name);
            $('.video-attachment-path:last').val(jsonStr.relativepath + jsonStr.name);

            $('.add-video-progress').remove();
            $('.add-video-item-delete').css('display', 'block');

            $('.add-video-item-delete').on('click', function () {
                $(this).parent('.add-video-item').remove();
            });
        } else {
            alert('视频上传失败');
        }
        if (xhr.status === 200 && xhr.readyState == 4) {

        }
    };

    // 上传失败
    xhr.onerror = function (evt) {
        alert('视频上传失败');
    };

    xhr.abort = function () {
        console.log('abort!!');
    };

    xhr.send(fd);
});

window.uploads = function (file) {
    if (!file.files || !file.files[0]) {
        alert('读取文件失败');
        return;
    }
    var reader = new FileReader();
    reader.onload = function (evt) {
        if (!picUploadPath) {
            picUploadPath = getPictureUploader();
            if (!picUploadPath) {
                alert('获取图片上传地址失败');
                return;
            }
        }

        $('#add_upload').ajaxSubmit({
            url: picUploadPath,
            type: 'post',
            success: function (rs) {
                if (rs !== undefined) {
                    if (rs.isOK == 1) {
                        var html = '';
                        html += '<div class="added_list_item">';
                        html += '<div class="shade-layer">';
                        html += '<img src="' + evt.target.result + '" style="width: 74px; height: 82px;" /></div>';
                        html += '<div class="added_item_delete">';
                        html += '<input type="hidden" class="attachment_name" value="' + rs.name + '" />';
                        html += '<input type="hidden" class="attachment_path" value="' + rs.relativepath + rs.name + '" />';
                        html += '</div>';
                        html += '</div>';

                        $('.add_pic_pop .added_list').append(html);
                    } else if (rs.errMessage !== undefined) {
                        console.log(rs.errMessage);
                        alert('图片上传失败:' + rs.errMessage);
                    } else {
                        console.log(rs);
                        alert('图片上传失败');
                    }
                }

                $('.added_item_delete').on('click', function () {
                    $(this).parent('.added_list_item').remove();
                });
            },
            error: function (data) {
                console.log(data);
                alert('上传图片失败');
            }
        });
    };
    reader.readAsDataURL(file.files[0]);
};